import { render, staticRenderFns } from "./SessaoExpirada.vue?vue&type=template&id=459b1107"
import script from "./SessaoExpirada.vue?vue&type=script&lang=js"
export * from "./SessaoExpirada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports